





























import Vue, { PropType } from 'vue';

import {
  ItemData,
  options,
} from 'mostra';

import {
  sizes,
  genDownloadImageUrlByImage,
  // genDownloadOriginalImageUrlEx
} from '@/modules/image';

interface DataType {
  imageSrc: string | null;
  loading: boolean;
}

export default Vue.extend({
  name: 'GCheckableItemListItem',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    item: {
      type: Object as PropType<ItemData>,
      required: true,
    },
    id: {
      type: String as PropType<string>,
      required: true,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  data(): DataType {
    return {
      imageSrc: null,
      loading: false,
    };
  },
  computed: {
    innerValue: {
      get(): string[] {
        return this.value;
      },
      set(val: string[]): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    getCategory() {
      const itemCategory = options.itemCategories.filter(
        (category) => category.value === this.item.category.categoryId,
      )[0];
      return itemCategory.text;
    },
    getSubCategory() {
      const itemCategory = options.itemCategories.filter(
        (category) => category.value === this.item.category.categoryId,
      )[0];
      const itemSubCategory = itemCategory.subs.filter(
        (category) => category.value === this.item.category.subCategoryId,
      )[0];
      return itemSubCategory.text;
    },
    async fetchItemImage() {
      // if (!this.item.base.topImage) return;
      try {
        this.loading = true;
        // const uid = this.$auth.uid;
        // const cid = this.$auth.cid;
        // const imageId = this.item.base.topImage.id;
        // if (!imageId) return;

        this.imageSrc = await genDownloadImageUrlByImage(
          sizes.x512,
          this.item.base.topImage,
        );
        // this.imageSrc = await genDownloadOriginalImageUrlEx(
        //   // cid,
        //   this.owner,
        //   imageId,
        // );
      } catch (error: any) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.fetchItemImage();
  },
});
